<template>
  <Card dis-hover shadow>
    <div slot="title">
      <Button type="primary" :to="{name: 'login-number'}" class="mr-3">
        <b>返回</b>
      </Button>
      <Button type="warning" :to="{name: 'add-login-number-inside', params: { id: $route.params.id } }" class="mr-3">
        <b>新增内页</b>
      </Button>
    </div>
    <lida-table :propscolumns="columns" :data="items"></lida-table>
    <modal-edit-inside ref="ModalEditInside" :data="modalData" v-on:reloadInside="reload" />
  </Card>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'login-number-inside',
  components: {
    ModalEditInside: () => import( /* webpackChunkName: "ModalEditInside" */ "./components/ModalEditInside.vue"),
  },
  data () {
    return {
      modalData: {},
      modalStatus: false,
      items: [],
      columns: {
        // SIid: {
        //   title: "登入内页编号",
        //   key: 'SIid',
        //   align: "center"
        // },
        InsideUrl: {
          title: "网址",
          key: 'InsideUrl',
          align: "center"
        },
        class: {
          title: "类别",
          key: 'class',
          align: "center",
          render: (h, params) => {
            let result;
            switch (params.row.class) {
              case 0:
                result = '未分类'
              break;
              case 1:
                result = '总公司'
              break;
              case 2:
                result = '代理'
              break;
              case 3:
                result = '会员'
              break;
            }
            return h('span', result)
          }
        },
        status: {
          title: "啟用 / 停用",
          key: 'status',
          align: "center",
          render: (h, params) => {
            return h('span', {
              style: {
                color: params.row.status == '1' ? 'green' : 'red'
              }
            }, params.row.status == '1' ? '啟用' : '停用')
          }
        },
        action: {
          title: "操作",
          key: 'action',
          align: "center",
          render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.openEdit()
                  this.modalData = JSON.parse(JSON.stringify(params.row));
                }
              }
            }, '修改')
          }
        },
      }
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  created () {
    this.getSiteSelect()
  },
  methods: {
    async getSiteSelect () {
      try {
        const res = await this.$axios.websiteManagement.setlineInside(this.$route.params.id)
        this.items = res
      } catch (error) {
        console.error(error);
      }
    },
    openEdit () {
      this.$refs.ModalEditInside.open()
    },
    reload () {
      this.getSiteSelect()
    }
  }
}
</script>